<template>
      <div class="box mt-20">
        <div class="box-header">
          <!-- <h3>선택정보 입력</h3> -->

          <h4>보안 서약서 관리</h4>
          <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
          <small>보안 서약서 추가 및 편집이 가능합니다.</small>
          <div class="pt-16 pb-7">
            <button class="btn btn-md line-2 mr-6" @click="addTos()">추가</button>
          </div>
        </div>

        <div v-for="(item, index) in tosList">
          <hr v-if="index != 0" class="thin">
          <div class="box-body">
            <div class="form-group row">
              <div class="col-12 form-control-label">

                <label class="form-control-label mr-20">
                  <b style="color:#187ed6;">보안서약서 {{index + 1}}</b>
                </label>

                <!--<button class="btn btn-sm line-2">편집<i class="icon-edit ml-5"></i></button>-->
                <!--<button class="btn btn-sm line-2 ml-5">비활성화<i class="icon-stop ml-5"></i></button>-->
                <!--<button class="btn btn-sm line-2 ml-5">활성화<i class="icon-reset ml-5"></i></button>-->
                <button class="btn btn-sm line-2 ml-5" @click="upsertItem(item)">저장<i class="icon-check ml-5"></i></button>
                <button v-if="!item.tosIndex" class="btn btn-sm line-2 ml-5" @click="removeTos(item)">취소<i class="icon-close ml-5"></i></button>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">타이틀</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" name="타이틀" class="form-control form-control-danger" v-model="item.tosTitle" :disabled="item.isEnable==0">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">필수 여부</span>
              </label>
              <div class="col-6 pt-2">
                <dropdown v-model="item.isRequired" displayName="display" valueName="value" :datasource="isRequired" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)" :editMode="item.isEnable==1?false:item.isEnable"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">활성 여부</span>
              </label>
              <div class="col-6 pt-2">
                <dropdown v-model="item.isEnable" displayName="display" valueName="value" :datasource="isEnable" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">서약서 동의 텍스트</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" name="서약서 동의 텍스트" class="form-control form-control-danger" v-model="item.tosAgreeText" :disabled="item.isEnable==0"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">서약서 내용</span>
              </label>
              <div class="col-6 pt-2">
                <textarea class="form-control form-control-success" v-model="item.tosContents" style="height: 200px;" :disabled="item.isEnable==0"> </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
  import PageHeader from '@/layout/PageHeader.vue'
  import dropdown from "@/components/Dropdown.vue"

  export default {
    components: {
      PageHeader,
      dropdown
    },

    data() {
      return {
        tosList: null,
        assetList: null,
        checkList: null,
        isEnable: [
          {display: '비활성', value: 0},
          {display: '활성', value: 1}
        ],
        isRequired: [
          {display: '선택', value: 0},
          {display: '필수', value: 1}
        ],
        checkType: null
      }
    },
    created(){

    },
    mounted(){
      this.init();
    },
    computed: {
      // isEdit(){
      //   return (item) =>{
      //     return item.isEdit;
      //   }
      // },
    },
    methods: {
      init(){
        this.getTosList();
        //this.getAssetList();
        //this.getCheckList();
        //this.getCheckType();
      },
      getTosList(){
        this.$http.get('/api/tos')
          .then((result) => {
            this.tosList = result.data;
          }).catch((e) =>{
          })
      },
      upsertItem(item) {
        if(item.tosIndex)
          this.updateItem(item)
        else
          this.insertItem(item);

      },
      insertItem(item){
        this.$http.post('/api/public/tos', item)
          .then((result) => {
            this.noti('완료','추가되었습니다.', 'success')
            this.getTosList();
          }).catch((e) =>{
        })
      },
      updateItem(item){
        this.$http.put('/api/public/tos', item)
          .then((result) => {
            this.noti('완료','수정되었습니다.', 'success')
            this.getTosList();
          }).catch((e) =>{
        })
      },
      removeTos(item){
        _.remove(this.tosList, x => x.tosUUID && x.tosUUID == item.tosUUID)
        this.$forceUpdate();
      },


      addTos(){
        let obj = {
          tosUUID : this.uuidv4(),
          tosTitle: '',
          tosAgreeText: '',
          tosContents: '',
          isRequired: 1,
          isEnable: 1
        };

        this.tosList.push(obj);
      }
    }
  }
</script>
<style>

</style>
